import { useState } from 'react'
import { useRenewal } from '../../../context/renewal'
import {
  ApplicationBodyContainer, 
  ApplicationBodyContent,
  DefaultTitle,
} from '../../../components/application/defaultComponents'
import {
  FormItemTitle,
  FlexDiv,
} from 'src/components/application/formComponents/styles'
import PrebuiltRenewalFooter from '../../../components/application/PrebuiltRenewalFooter'
import { LeftBar } from 'src/components/basic/LeftBar'
import { RenewalData } from 'src/dtos/renewalData'
import StepBullet from '../../../components/basic/StepBullet'
import StandardInput from 'src/components/basic/StandardInput'
import StandardRadio from 'src/components/basic/StandardRadio'
import { hasICOCAttorneys } from 'src/utils/renewals'

const SolePractitioner = () => {
  const { renewalData } = useRenewal()
  const [solePractitionerThisYear, setSolePractitionerThisYear] = useState<string | undefined>(renewalData?.attorneysSection?.solePractitionerThisYear)
  const [solePractitionerLastYear, setSolePractitionerLastYear] = useState<string | undefined>(renewalData?.attorneysSection?.solePractitionerLastYear)
  const [reasonLessThanFourtyHours, setReasonLessThanFourtyHours] = useState<string | undefined>(renewalData?.attorneysSection?.reasonLessThanFourtyHours)
  const [isOtherOptionChecked, setIsOtherOptionChecked] = useState(
    !!renewalData?.attorneysSection?.reasonLessThanFourtyHours &&
    renewalData?.attorneysSection?.reasonLessThanFourtyHours !== 'Family' &&
    renewalData?.attorneysSection?.reasonLessThanFourtyHours !== 'Leisure'
  )
  const [showErrors, setShowErrors] = useState(false)
  
  const updatedApplicationData = (): RenewalData => ({
    ...renewalData,
    currentPage: window.location.pathname,
    attorneysSection: {
      ...renewalData?.attorneysSection,
      solePractitionerThisYear,
      solePractitionerLastYear,
      reasonLessThanFourtyHours
    }
  })

  const validatePage = () => {
    //if(!solePractitionerLastYear) return false  //disabled front end validation
    return true
  }

  const handleScrollIfInvalid = () => {
    if(validatePage() === false) {
      setShowErrors(true)
      document.getElementById('step1')?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const goNextRoute = () => {
    const hasICOC = hasICOCAttorneys(updatedApplicationData())

    if(hasICOC) {
      return '/customer/renew/attorneys/ic-oc'
    }

    return '/customer/renew/questions/main'
  }
  
  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Please provide details about Applicant’s work as a sole practitioner</DefaultTitle>
        <FlexDiv margin='24px 0 0 0' gap="12px">
          <StepBullet id="step1">1</StepBullet>
          <FlexDiv dir="column">
            <FormItemTitle style={{ fontSize: '18px' }}>
              Average hours worked per week for this firm during the <span id='last12months'>last 12 months</span>, not including work performed as an Independent Contractor or Of Counsel.
            </FormItemTitle>
            <small style={{ color: '#52545D', fontSize: '14px' }}>(Not just billable hours)</small>
            <FlexDiv dir="column" gap="24px" maxWidth='100px' margin="24px 0 0 0">
              <StandardInput
                label=""
                type="number"
                value={solePractitionerLastYear ?? ''}
                onChange={e => setSolePractitionerLastYear(e.target.value)}
                isIncorrect={showErrors && !solePractitionerLastYear}
                errorMessage={showErrors && !solePractitionerLastYear ? 'This is a required field' : ''}
                errorCode='EC120'
              />
            </FlexDiv>
          </FlexDiv>
        </FlexDiv>
        <FlexDiv margin='24px 0 0 0' gap="12px">
          <StepBullet>2</StepBullet>
          <FlexDiv dir="column">
            <FormItemTitle style={{ fontSize: '18px' }}>
              Estimated average hours worked per week for this firm during the <span id='next12months'>next 12 months</span>, not including work performed as an Independent Contractor or Of Counsel.
            </FormItemTitle>
            <small style={{ color: '#52545D', fontSize: '14px' }}>(Not just billable hours)</small>
            <FlexDiv dir="column" gap="24px" maxWidth='100px' margin="24px 0 0 0">
              <StandardInput
                label=""
                type="number"
                value={solePractitionerThisYear ?? ''}
                onChange={e => setSolePractitionerThisYear(e.target.value)}
                errorCode='EC121'
              />
            </FlexDiv>
            <FlexDiv gap="24px" margin="24px 0 0 0">
              <LeftBar />
              <FlexDiv dir="column" gap="20px" maxWidth='300px'>
                <FormItemTitle style={{ fontSize: '14px' }}>If less than 40 hours, please provide the reason:</FormItemTitle>
                <StandardRadio
                  label="Family"
                  checked={reasonLessThanFourtyHours === 'Family'}
                  value="Family"
                  onChange={() => {}}
                  onClick={(e) => {
                    const {value} = e.currentTarget
                    setReasonLessThanFourtyHours(prev => value === prev ? '' : value)
                    setIsOtherOptionChecked(false)
                  }}
                  
                />
                <StandardRadio
                  label="Leisure"
                  checked={reasonLessThanFourtyHours === 'Leisure'}
                  value="Leisure"
                  onChange={() => {}}
                  onClick={(e) => {
                    const {value} = e.currentTarget
                    setReasonLessThanFourtyHours(prev => value === prev ? '' : value)
                    setIsOtherOptionChecked(false)
                  }}
                  
                />
                <FlexDiv gap="8px" align='center'>
                  <StandardRadio
                    label="Other: "
                    value="Other"
                    checked={isOtherOptionChecked}
                    onChange={() => {}}
                    onClick={() => {
                      setIsOtherOptionChecked(prev => !prev)
                      setReasonLessThanFourtyHours('')
                    }}
                    
                  />
                  <StandardInput
                    label=""
                    disabled={!isOtherOptionChecked}
                    value={isOtherOptionChecked ? reasonLessThanFourtyHours : ''}
                    onChange={e => setReasonLessThanFourtyHours(e.target.value)}
                    errorCode='EC122'
                  />
                </FlexDiv>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
        </FlexDiv>
      </ApplicationBodyContent>
      <PrebuiltRenewalFooter
        goBackRoute='/customer/renew/attorneys/verify'
        nextRoute={goNextRoute()}
        updatedApplication={updatedApplicationData()}
        isFormValid={validatePage()}
        beforeSaveContinueClick={handleScrollIfInvalid}
      />
    </ApplicationBodyContainer>
  )
}

export default SolePractitioner